/*
 * Author: Dw
 * File Created: Monday, 24-10-21 05:22 pm
 * Last Modified: Monday, 24-10-21 05:25 pm, by Dw
 */

function Plus() {
  return <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="Plus" data-sentry-source-file="index.tsx">
      <path fillRule="evenodd" clipRule="evenodd" d="M18.0004 21.9999V35.0004H22.0004V21.9999H35V17.9999H22.0004V5.00037H18.0004V17.9999H5V21.9999H18.0004Z" fill="white" data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
}
export default Plus;